import {useState, useEffect, useCallback} from 'react';
import PropTypes from 'prop-types';
import {toggleArrayInclusion} from '@ozgene/gp5.utils.array-functions';
import once from 'once';
import StepListContainer from 'SbsSuite/Container/StepListContainer';
import {
  findStepsBySbs,
  saveStepAfter,
  saveStepLists,
} from 'StepUpdateCreate/service/StepService';
import {deleteSbs, findParentSbs, findSbs} from 'Sbs/service/SbsService';

export default function SbsSuiteContainer(props, context) {
  const {
    location,
    params: {sbsId},
  } = props;
  const {router} = context;
  const [isLoading, setIsLoading] = useState(true);
  const [sbs, setSbs] = useState(null);
  const [sbsSuiteStep, setSbsSuiteStep] = useState(null);
  const [parentSbss, setParentSbss] = useState(null);
  const [duplicationMode, setDuplicationMode] = useState(false);
  const [duplicationSelectedSteps, setDuplicationSelectedSteps] = useState([]);
  const handleDuplicateSteps = once(async () => {
    const {id} = await saveStepLists(duplicationSelectedSteps);

    router.push({pathname: `Sbss/${id}`});
  });
  const handleRetrieveSbs = async (sbsId) => {
    const newSbs = await findSbs(sbsId);

    setSbs(newSbs);
  };
  const handleAddToSchedule = async (step) => {
    setSbsSuiteStep(step);
  };
  const handleDeleteFirstStep = useCallback(
    () => setSbs((existing) => ({...existing, firstStep: null})),
    [],
  );
  const handleRetrieveParentSbs = async (sbsId) => {
    const newParentSbss = await findParentSbs(sbsId);

    setParentSbss(newParentSbss);
    setIsLoading(false);
  };
  const handleSaveStep = async (savedStepId) => {
    const {
      sbs: {id: sbsId},
    } = await saveStepAfter(savedStepId);

    handleRetrieveSbs(sbsId);
  };
  const handleCancelStep = () => {
    // TODO: implement a better alert system
    // eslint-disable-next-line no-alert
    alert('Did you know: an SBS without a step makes no sense?');
  };
  const handleDeleteSbs = async () => {
    // TODO: implement a better alert system
    // eslint-disable-next-line no-restricted-globals, no-alert
    if (confirm(`Are you sure you want to delete ${sbs.title}?`)) {
      await deleteSbs(sbs);
      router.replace({pathname: 'Sbss'});
    }
  };
  const handleRetrieveSteps = async (sbs, startStepId) =>
    await findStepsBySbs(sbs.id, startStepId);
  const handleToggleDuplicationMode = (event) =>
    setDuplicationMode(event.target.checked);
  const handleDuplicationToggleSelectedStep = (stepId) =>
    setDuplicationSelectedSteps((existing) =>
      toggleArrayInclusion(existing, stepId),
    );
  const handleToggleSelectAllSteps = async () => {
    if (duplicationSelectedSteps.length === 0) {
      const steps = await handleRetrieveSteps(sbs);

      setDuplicationSelectedSteps(steps.map((step) => step.id));
    } else {
      setDuplicationSelectedSteps([]);
    }
  };

  useEffect(() => {
    const start = async () => {
      await handleRetrieveSbs(sbsId);
      await handleRetrieveParentSbs(sbsId);
      setIsLoading(false);
    };

    if (sbsId) start();
  }, [sbsId]);

  return (
    !isLoading && (
      <StepListContainer
        location={location}
        sbs={sbs}
        onSaveStep={handleSaveStep}
        onCancelStep={handleCancelStep}
        parentSbss={parentSbss}
        onAddToSchedule={handleAddToSchedule}
        onDeleteSbs={handleDeleteSbs}
        duplicationMode={duplicationMode}
        onToggleDuplicationMode={handleToggleDuplicationMode}
        duplicationSelectedSteps={duplicationSelectedSteps}
        onDuplicationToggleSelectedStep={handleDuplicationToggleSelectedStep}
        onToggleSelectAllSteps={handleToggleSelectAllSteps}
        onDuplicateSteps={handleDuplicateSteps}
        onDeleteFirstStep={handleDeleteFirstStep}
      />
    )
  );
}

SbsSuiteContainer.propTypes = {
  location: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
};

SbsSuiteContainer.contextTypes = {
  router: PropTypes.object.isRequired,
};
